import _color from '@/assets/utils/color.js';
<template>
  <div class="mx-auto w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ...">
    <vx-card title="Error Items">
      <!-- <ul>
        <li v-for="(err,index) in errdata" :key="index">{{err}}</li>
      </ul> -->
      <p>{{errdata}}</p>
      <br />
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      skus_code: ""
    };
  },
  components: {},
  props: ["errdata"],
  methods: {
    clsd: function() {
      this.skus_code = "";
    }
  },
  beforeCreate() {},
  created() {
    // console.log(this.$router.currentRoute);
  }
};
</script>

<style scoped>
li {
  color: red;
}
</style>
